"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgLock(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.957 0a5.872 5.872 0 015.869 5.652l.004.22-.001 2.298h1.277c1.49 0 2.715 1.17 2.804 2.638l.005.17v10.213A2.815 2.815 0 0119.106 24H4.81A2.815 2.815 0 012 21.191V10.98A2.815 2.815 0 014.809 8.17h1.276V5.873A5.874 5.874 0 0111.957 0zm7.15 9.702H4.808c-.7 0-1.277.576-1.277 1.277V21.19c0 .7.576 1.277 1.277 1.277h14.297c.7 0 1.277-.576 1.277-1.277V10.98c0-.7-.576-1.277-1.277-1.277zM11.956 12a2.042 2.042 0 01.767 3.937v2.19a.766.766 0 01-1.526.105l-.007-.104v-2.191A2.042 2.042 0 0111.957 12zm0-10.468a4.342 4.342 0 00-4.335 4.13l-.005.21V8.17h8.68V5.872a4.34 4.34 0 00-4.34-4.34z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgLock;
exports.default = _default;